import React, { useState, useEffect } from 'react';
import '../../App.css';
import './css/SignUp.css';
import axios from "axios";
import { googleLogout, useGoogleLogin  } from '@react-oauth/google';

function SignUp() {
    const [inputs, setInputs] = useState({});
	const [credentialError, setCredentialError] = useState('');
    const handleChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        setInputs(values => ({...values, [name]: value}))
    }
    const [ user, setUser ] = useState([]);
    const [ guser, setGUser ] = useState([]);
    const [userP, ViewPhone] = useState(false)

    const glogin = useGoogleLogin({
        onSuccess: (codeResponse) => setUser(codeResponse),
        onError: (error) => console.log('Login Failed:', error)
    });

    const handleSubmit = (event) => {
        event.preventDefault();
        console.log(inputs.firstname);
		axios.post('https://api.bubble.africa/users/signup', {
			first_name: inputs.firstname,
			last_name: inputs.lastname,
			email: inputs.email,
			password: inputs.password,
            phone: inputs.phone,
		})
            .then((res) => {
				setCredentialError("Registration successful");
                console.log(res.data)
				window.location.href='/login';
            }).catch((error) => {
                console.log(error)
				setCredentialError(error.response.data.message);
            });
			
			
		// const response = axios.post("http://bubble-devapi.herokuapp.com/api/v1/users", 
			// inputs,
			// {
                    // headers: { 'Content-Type': 'application/json' }
             // }
		  // );
		// console.log(response.data);
	}
    useEffect(
        () => {
            if (user) {
                axios
                    .get(`https://www.googleapis.com/oauth2/v1/userinfo?access_token=${user.access_token}`, {
                        headers: {
                            Authorization: `Bearer ${user.access_token}`,
                            Accept: 'application/json'
                        }
                    })
                    .then((res) => {
                        setGUser(res.data);
                        console.log(res.data);
                        ViewPhone(true)
                        // const guser  = res.data;
                        
                    })
                    .catch((err) => console.log(err));
            }
        },
        [ user ]
    );
    
    // const userPhone = () => {
    //     ViewPhone(true)
    // }

    const handleGSubmit = (event) => {
        event.preventDefault();
        axios.post('https://api.bubble.africa/users/signup', {
            first_name: guser.given_name,
            last_name: guser.family_name,
            email: guser.email,
            password: guser.id,
            phone: inputs.phone,
            gUser: true
        }).then((res) => {
            setCredentialError("Registration successful");
            console.log(res.data);
            localStorage.setItem('user', JSON.stringify(res.data));
            window.location.href='/login';
        }).catch((error) => {
            console.log(error)
            setCredentialError(error.response.data);
        });
        
        // console.log(inputs.firstname);
		// axios.post('https://api.bubble.africa/users/signup', {
			
		// })
        //     .then((res) => {
		// 		setCredentialError("Registration successful");
        //         console.log(res.data)
		// 		window.location.href='/login';
        //     }).catch((error) => {
        //         console.log(error)
		// 		setCredentialError(error.response.data.message);
        //     });
			
			
		// const response = axios.post("http://bubble-devapi.herokuapp.com/api/v1/users", 
			// inputs,
			// {
                    // headers: { 'Content-Type': 'application/json' }
             // }
		  // );
		// console.log(response.data);
	}

    const logOut = () => {
        googleLogout();
    };
		
    return (
        <div className='container'>
            <div className='signup-container'>
                <img className='signup-logo' src='../../bubbleafrica.png' alt='logo'/>
                <h3 className='subheader green-text'>Welcome To Bubble</h3>
                
                {
                    userP ? (
                        <>
                            <p className='maintext signup-sub'>{credentialError ? credentialError: "Please Enter Your Phone Number"}</p>
                            <form className='signup' onSubmit={handleGSubmit}>
                                <input disabled name="email" value={guser.email || ""} onChange={handleChange} type="email" className="signup-input" placeholder="Enter your email address" />
                                <input name="phone" value={inputs.phone || ""} onChange={handleChange} type="text" className="signup-input" placeholder="Enter your phone number" />
                                <button className='signup-submit' type = 'submit'>Sign Up</button>   
                            </form>
                        </>
                    ) : (
                        <>
                            <p className='maintext signup-sub'>{credentialError ? credentialError: "Get Started"}</p>
                            <div className='continuewithgoogle'>
                                <div className='google-text'>
                                    {/* <GoogleLogin onSuccess={responseMessage} onError={errorMessage} /> */}
                                    <p onClick={() => glogin()} className='googletext'>Continue with Google  <img src='../../images/google-logo.png' alt='google-logo' width='21px' />
                                    </p>
                                </div>
                            </div>
                            <div className='signup-group'>
                                <hr className='signup-hr'/>
                                <p className='maintext'>or</p>
                                <hr className='signup-hr'/>
                            </div>
                            <form className='signup' onSubmit={handleSubmit}>
                                <input name="firstname" value={inputs.firstname || ""} onChange={handleChange} type="text" className="signup-input" placeholder="Enter your first name" />
                                <input name="lastname" value={inputs.lastname || ""} onChange={handleChange} type="text" className="signup-input" placeholder="Enter your last name" />
                                <input name="email" value={inputs.email || ""} onChange={handleChange} type="email" className="signup-input" placeholder="Enter your email address" />
                                <input name="phone" value={inputs.phone || ""} onChange={handleChange} type="text" className="signup-input" placeholder="Enter your phone number" />
                                <input name="password" value={inputs.password || ""} onChange={handleChange} type="password" className="signup-input" placeholder="Enter your password" />
                                <button className='signup-submit' type = 'submit'>Sign Up</button>
                                {/* <input type="submit" className='signup-submit' value="Sign Up"/> */}
                            </form>
                        </>
                    )
                }
                
                {/* <p>{testing}</p> */}
                <p className='subtext'>Have an account? <a href="/login">Sign in</a></p>
                <p className='subtext signup-terms'>By signing up, you agree to our <a href="#">Terms and Condition</a></p>
            </div>
        </div>
    )
}

export default SignUp;